import React, { useState, useRef, useCallback, ChangeEvent } from 'react';
import * as Yup from 'yup';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { IoIosCloseCircleOutline } from 'react-icons/io';
import { FiCamera } from 'react-icons/fi';
import { AiOutlineGroup } from 'react-icons/ai';

import api from '../../../../../../services/api';
import { useRegisterAdded } from '../../../../../../hooks/registerAdded';
import no_image from '../../../../../../assets/no_image.png';
import InputLogged from '../../../../../../components/InputLogged';
import { useToast } from '../../../../../../hooks/toast';
import getValidationErrors from '../../../../../../utils/getValidationErrors';

import {
  SubmitButtonWrapper,
  SubmitButton,
  MenuOptionButton,
} from '../../../styles';
import {
  DrawerTitle,
  DrawerInputWrapper,
  ImgInputWrapper,
  GrupoImgWrapper,
  DrawerContainer,
  CloseButton,
} from '../../drawer_styles';
import material_styles from '../../drawer_styles/material_styles';

interface Props {
  grupo_id: number;
  descricao: string;
  imagem: string;
}

const EditGrupoSimples: React.FC<Props> = ({ grupo_id, descricao, imagem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [grupoImg, setGrupoImg] = useState<File | string>(imagem);
  const [descricaoGrupo, setDescricaoGrupo] = useState(descricao);

  const { addToast } = useToast();
  const { handleSetHasGroupUpdated } = useRegisterAdded();

  const toggleDrawer = (open: boolean) => () => {
    setIsOpen(open);
  };

  const formRef = useRef<FormHandles>(null);
  const classes = material_styles();

  const handleGrupoImgChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        const data = new FormData();
        data.append('grupo_img', e.target.files[0]);

        api.patch(`/grupo/${grupo_id}`, data).then((response) => {
          setGrupoImg(response.data.imagem);

          addToast({
            type: 'success',
            title: 'Imagem do Grupo Atualizada',
          });
        });
      }
    },
    [grupo_id, addToast],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          descricao: Yup.string().required('O nome do grupo é obrigatório.'),
        });

        await schema.validate(data, { abortEarly: false });

        api
          .put(`/grupo/${grupo_id}`, { descricao: data.descricao })
          .then((responseData: any) => {
            setDescricaoGrupo(responseData.data.descricao);

            addToast({
              type: 'success',
              title: 'Dados atualizados.',
            });

            handleSetHasGroupUpdated(true);
            setIsOpen(false);
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          addToast({
            type: 'error',
            title: 'Preencha os dados corretamente pra continuar',
          });
        } else {
          const { message } = err.response.data;

          addToast({
            type: 'error',
            title: message,
          });
        }
      }
    },
    [addToast, grupo_id, handleSetHasGroupUpdated],
  );

  return (
    <>
      <MenuOptionButton type="button" onClick={toggleDrawer(true)}>
        Editar Grupo
      </MenuOptionButton>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation">
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle>
                <h1>Edição de Grupo</h1>
                <span>
                  Você está editando os dados do grupo <b>{descricaoGrupo}</b>.
                </span>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <Form
                ref={formRef}
                onSubmit={handleSubmit}
                initialData={{ descricao }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} className={classes.noPaddingBot}>
                    <GrupoImgWrapper>
                      <ImgInputWrapper>
                        <img
                          src={
                            grupoImg
                              ? `${process.env.REACT_APP_SERVER_URL}/files/${grupoImg}`
                              : no_image
                          }
                          alt="Grupo"
                        />

                        <label htmlFor="grupo_img">
                          <FiCamera size={20} />
                          <input
                            type="file"
                            id="grupo_img"
                            onChange={handleGrupoImgChange}
                          />
                        </label>
                      </ImgInputWrapper>
                    </GrupoImgWrapper>
                  </Grid>

                  <Grid item xs={12} className={classes.noPaddingTop}>
                    <DrawerInputWrapper>
                      <span>Nome:</span>

                      <InputLogged
                        name="descricao"
                        placeholder="Nome do Grupo"
                        icon={AiOutlineGroup}
                      />
                    </DrawerInputWrapper>
                  </Grid>

                  <Grid item xs={12} />

                  <Grid item xs={12}>
                    <SubmitButtonWrapper>
                      <SubmitButton type="submit">Salvar</SubmitButton>
                    </SubmitButtonWrapper>
                  </Grid>
                </Grid>
              </Form>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default EditGrupoSimples;
